import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { Employees } from 'modules/employees/store/collections/employees'
import { employeeLocation } from 'modules/locations/store/collections/locations'

interface LocationProps {
  respondentId: number
  employees: Employees
}

function Location({ respondentId, employees }: LocationProps) {
  const employee = employees.find({
    access_id: String(respondentId),
  })
  const location = employee ? employeeLocation(employee.attributes.location_id) : null

  if (!location) return <>-</>

  return <Text.Normal>{location.attributes.name}</Text.Normal>
}

export default observer(Location)
